import styled from 'styled-components';

export const SocialWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 16px;
  justify-content: center;
  color: grey;

  button {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  p {
    margin-top: 0;
    margin-bottom: 5px;
  }
`;
type LinkButtonProps = {
  isSelected: boolean;
};
export const LinkButton = styled.div<LinkButtonProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

  li {
    background-color: #f0f0f0;
    & div {
      background-color: #f0f0f0 !important;
    }
    svg {
      color: #6c757d !important;
    }
  }

  ${({ isSelected }) =>
    isSelected &&
    `
    li {
      background-color: #aec5f1;
      & div {
        background-color: #aec5f1 !important;
      }
      svg {
        color: #0055FB !important;
      }
    }
  `}
`;
